import React, {useState} from "react";
import useStyles from "./style";
import {Button, TextField} from "@material-ui/core";
import Header from "./componets/Header";

const PrintStickersCalculator = () => {
    const cl = useStyles();
    const [data, setData] = useState({consignment: '', date: '', amount: 40, error: undefined});

    const handleCreateZPL = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (data.consignment.length > 0 && data.date.length > 0 && data.amount > 0 && !data.error) {
            setData(prevState => ({...prevState, error: undefined}));
            const res = '^XA~JSB\n' +
                '^FO30,20\n' +
                '^APN,1\n' +
                '^CWZ,E:TT0003M_.FNT^FS\n' +
                '^FO60,10^CI28^AZN,45,35\n' +
                '^FDПартія ^FS\n' +
                '^FO60,70^CI28^AZN,25,15\n' +
                '^FT190,40^A0N,35,35^FH\\^FDLOT^FS\n' +
                '^FO180,1^GB80,50,4^FS\n' +
                '^FO60,70^CI28^AZN,45,30\n' +
                `^FD${data.consignment}^FS\n` +
                '^FO60,125^CI28^AZN,35,25\n' +
                `^FDØ ${data.date}^FS\n` +
                '^XZ\n' +
                '^XA\n' +
                '^FO70,10^CI28^AZN,15,10\n' +
                '^XZ\n';
            let template = "";

            for (let i = 0; i <= data.amount; i++) {
                template = template + res;
            }

            const url = window.URL.createObjectURL(new Blob([template], {type: 'text/plain'}));

            const link = document.createElement('a');
            link.href = url;
            link.download = `stickers.zpl`;
            link.click();
            link.remove();
        } else {
            setData(prevState => ({...prevState, error: 'Введіть номер партії та дату, щоб створити наклейки.'}));
        }
    };

    const handleChange = (e) => {
        e.persist();

        setData(prevState => ({...prevState, error: undefined,[e.target.name]: e.target.value}));

        if (e.target.name === 'amount' && (+e.target.value < 1 || !e.target.value)) {
            setData(prevState => ({...prevState, error: 'Кількість наклейок не можу бути меншою за одиницю.'}));
        }
    };

    return (<div className={cl.rootPrintStickers}>
        <Header/>
        <TextField
            className={cl.printStickersField}
            autoFocus
            autoComplete="off"
            value={data.consignment}
            variant="outlined"
            name="consignment"
            color="primary"
            label="Лот"
            placeholder="номер лоту"
            onChange={handleChange}
        />
        <TextField
            className={cl.printStickersField}
            autoComplete="off"
            value={data.date}
            variant="outlined"
            name="date"
            color="primary"
            label="Дата придатності"
            placeholder="РРРР-ММ-ДД"
            onChange={handleChange}
        />
        <TextField
            className={cl.printStickersField}
            value={data.amount}
            variant="outlined"
            autoComplete="off"
            InputProps={{ inputProps: { min: 1 } }}
            name="amount"
            color="primary"
            type="number"
            label="Кількість наклейок"
            onChange={handleChange}
        />
        <Button
            color="primary"
            variant="contained"
            onClick={handleCreateZPL}
        >
            передати на друк
        </Button>
        {data.error && <p className={cl.error}>{data.error}</p>}
    </div>);
};

export default PrintStickersCalculator;
